/**
 * Resolves once the app's first screen has drawn and the browser is idle
 * (fastphone-2). After that it resolves at once, so it only ever delays the
 * cold open, never a later page.
 *
 * For reads the first screen does not draw: the agents' photos and handles, the
 * CRM's dates, the books-health score, the orb's risk ledger, the marketplace
 * overview. On a cold open they were asked alongside the screen's own reads,
 * and `crm-facts` alone took 3 s. Now they wait their turn.
 */
let ready: Promise<void> | null = null;

export function afterFirstPaint(): Promise<void> {
    if (ready) return ready;
    // Tests and server rendering have no first paint to wait for.
    if (typeof window === 'undefined' || import.meta.env.MODE === 'test') return (ready = Promise.resolve());
    ready = new Promise<void>((resolve) => {
        const idle = () => {
            const ric = (window as Window & { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => number }).requestIdleCallback;
            if (ric) ric(() => resolve(), { timeout: 2_000 });
            else setTimeout(resolve, 200);
        };
        // A beat after load, so the first screen's own reads go out first.
        const go = () => setTimeout(idle, 800);
        if (document.readyState === 'complete') go();
        else window.addEventListener('load', go, { once: true });
    });
    return ready;
}
